module.exports = __webpack_public_path__ + "static/ssb-day1-3a9b35ef5ed4ccea1b567a9c3e31a1f9.png";